angular.module('egAngularUtils', [
    'ng'
]);